<template>
    <div>
        <div id="myCarousel" class="carousel slide"  data-interval="false">
            <!-- 轮播（Carousel）指标 -->
            <ol class="carousel-indicators">
                <li data-target="#myCarousel" data-slide-to="0" class="active"></li>
                <li data-target="#myCarousel" data-slide-to="1"></li>
                <li data-target="#myCarousel" data-slide-to="2"></li>
            </ol>
            <!-- 轮播（Carousel）项目 -->
            <div class="carousel-inner">
                <div class="item active">
                    <img src="../assets/image/we/onlinea.jpg" style="width:100%;min-width:1000px;">
                </div>
                <div class="item">
                    <img src="../assets/image/we/onlineb.jpg" style="width:100%;min-width:1000px;">
                </div>
                <div class="item">
                    <img src="../assets/image/we/onlinec.jpg" style="width:100%;min-width:1000px;">
                </div>
            </div>
            <a class="left carousel-control" href="#myCarousel" role="button" data-slide="prev" style="height: 85%">
                <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
            </a>
            <a  class="right carousel-control" href="#myCarousel" role="button" data-slide="next" style="height: 85%">
                <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
            </a>
        </div>

        <div class="container" style="margin-top: 40px;">
            <div class="row" style="margin-left: -12px;margin-right: 2px;margin-bottom: 20px;">
                <video style="margin-top: -4%;"  width="100%" controls poster="https://gss0.baidu.com/7LsWdDW5_xN3otqbppnN2DJv/space/pic/item/6f061d950a7b02082bdbc9b16dd9f2d3572cc854.jpg" >
                    <source src="https://alivideo.54traveler.com/video/54traveler_final.mp4"  type="video/mp4">
                </video>
            </div>
            <div class="row" style="margin: 0 -26px;">
                <div class="col-xs-4" style="">
                    <video style="margin-top: -2%;"  width="100%" controls poster="https://gss0.baidu.com/7LsWdDW5_xN3otqbppnN2DJv/space/pic/item/6f061d950a7b02082bdbc9b16dd9f2d3572cc854.jpg" >
                        <source src="https://alivideo.54traveler.com/video/54traveler_final.mp4"  type="video/mp4">
                    </video>
                    <p style="margin: 0;font-weight: bold">
                        <span style="margin-left: 20px;">人生第三次</span>
                    </p>
                    <p style="margin: 0;">
                        <span style="margin-left: 20px;">我是一行副标题，而已。。。</span>
                    </p>
                </div>
                <div class="col-xs-4" style="">
                    <video style="margin-top: -2%;"  width="100%" controls poster="https://gss0.baidu.com/7LsWdDW5_xN3otqbppnN2DJv/space/pic/item/6f061d950a7b02082bdbc9b16dd9f2d3572cc854.jpg" >
                        <source src="https://alivideo.54traveler.com/video/54traveler_final.mp4"  type="video/mp4">
                    </video>
                    <p style="margin: 0;font-weight: bold">
                        <span style="margin-left: 20px;">人生第三次</span>
                    </p>
                    <p style="margin: 0;">
                        <span style="margin-left: 20px;">我是一行副标题，而已。。。</span>
                    </p>
                </div>
                <div class="col-xs-4" style="">
                    <video style="margin-top: -2%;"  width="100%" controls poster="https://gss0.baidu.com/7LsWdDW5_xN3otqbppnN2DJv/space/pic/item/6f061d950a7b02082bdbc9b16dd9f2d3572cc854.jpg" >
                        <source src="https://alivideo.54traveler.com/video/54traveler_final.mp4"  type="video/mp4">
                    </video>
                    <p style="margin: 0;font-weight: bold">
                        <span style="margin-left: 20px;">人生第三次</span>
                    </p>
                    <p style="margin: 0;">
                        <span style="margin-left: 20px;">我是一行副标题，而已。。。</span>
                    </p>
                </div>
            </div>

            <div class="row" style="margin-bottom: 60px;margin-top: 20px;background-color: #fbfbfb;">
                <div style="margin: 0 auto;width: 90%;">
                    <h2>城市行走·CityWalks</h2>
                    <p class="text-muted" id="texta" v-show="textShow">你所熟悉的环境里，去探索你不熟悉的故事、风景和体验。
                        精心设计的每一条线路，就是为了和你一起发现这座
                        CityWalks不是走马观花，也不是暴走，而是旅行在城市中延伸。在城市平凡却最惊喜之处。带着一颗发现的心，拥抱属于你的城市，你会发现这座城市、那些人们，都足够可爱。
                        CityWalks不是走马观花，也不是暴走，而是旅行在城市中延伸。在你所熟悉的环境里，去探索你不熟悉的故事、风景和体验。
                        精心设计的每一条线路，就是为了和你一起发现这座城市平凡却最惊喜之处。带着一颗发现的心，拥抱属于你的城市，你会发现这座城市、那些人们，都足够可爱。
                    </p>
                    <p class="text-muted" id="textb" v-show="!textShow">
                        CityWalks不是走马观花，也不是暴走，而是旅行在城市中延伸。在你所熟悉的环境里，去探索你不熟悉的故事、风景和体验。
                        精心设计的每一条线路，就是为了和你一起发现这座城市平凡却最惊喜之处。带着一颗发现的心，拥抱属于你的城市，你会发现这座城市、那些人们，都足够可爱。
                        CityWalks不是走马观花，也不是暴走，而是旅行在城市中延伸...<span style="color: #E60012;cursor: pointer" id="look" @click="lookthis()">查看更多</span>
                    </p>
                </div>
                <div style="width: 100%;">
                    <img src="../assets/image/we/onlinebottom2.png" style="width:100%;">
                </div>
                <div style="width: 100%;">
                    <img src="../assets/image/we/onlinebottom.png" style="width:100%;">
                </div>

                <!--<img src="../assets/image/we/onlinebottom.jpg" style="width: 100%;">-->
                <!--<img src="../assets/image/we/onlinebottom.jpg" style="width: 100%;">-->
            </div>




        </div>
    </div>
</template>
<script>
  export default {
    data () {
      return {
        textShow: false
      }
    },
    methods: {
      goSecond () {
        var url = '/'
        window.open(url)
      },
      lookthis () {
        this.textShow = true
      }
    }
  }
</script>
<style scoped>
  .container{
      width: 1000px;
  }
  .we-part{
      padding-top: 55px;
      padding-bottom: 80px;
  }
  .we-part img{
      width: 100%;
      height: 100%;
  }
  .we-part:nth-child(odd){
      background-color: #fff;
  }
  .we-part:nth-child(even){
      background-color: #fbfbfb;
  }
  .we-part .container:nth-child(2){
      padding: 0;
  }
  h2{
      font-weight: bold;
      margin-bottom: 20px;
      text-align: left;
      font-size: 24px;
  }
  .col-xs-10.col-xs-offset-1{
      margin-bottom: 45px;
  }
</style>



/** WEBPACK FOOTER **
 ** Online.vue?a1db6a36
 **/